import { h, Component, Prop, forceUpdate } from '@stencil/core';
import state, { store } from '../state';
import { NotificationSubmitEventArg } from '../types';

@Component({
  tag: 'om-notification-screen-switcher',
})
export class NotificationScreenSwitcher {
  @Prop() handleAction: (d: NotificationSubmitEventArg) => void;
  @Prop() unmount?: () => void;

  render() {
    // Get notification content (single screen)
    const notificationContent = state.content;

    if (!notificationContent) {
      return null;
    }

    // Skip hidden screens
    if (notificationContent.shouldHide) {
      return null;
    }

    return (
      <om-notification-screen
        handleAction={this.handleAction}
        screenValues={notificationContent}
        unmount={this.unmount}
      />
    );
  }

  componentDidRender() {
    if (state.mode !== 'preview') return;
    store.onChange('content', () => forceUpdate(this));
  }
}
